module.exports = __webpack_public_path__ + "static/media/book1.caaafccf.jpg";